"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.isFunction = exports.convertToSeconds = void 0;
function convertToSeconds(value, defaultValue) {
    if (value && Number.isInteger(value)) {
        return value / 1000;
    }
    return defaultValue;
}
exports.convertToSeconds = convertToSeconds;
const isFunction = (val) => typeof val === 'function';
exports.isFunction = isFunction;
function round(value, decimalPlaces = 2) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
}
exports.round = round;
//# sourceMappingURL=number-utils.js.map